"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductTour = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_joyride_1 = __importDefault(require("react-joyride"));
var ProductTour = function (props) {
    return ((0, jsx_runtime_1.jsx)(react_joyride_1.default, { steps: props.steps, continuous: true, showSkipButton: true, run: props.showTour, styles: {
            options: {
                textColor: '#0c0c0c',
                zIndex: 10000
            },
            beaconInner: {
                backgroundColor: '#3f4041',
            },
            beaconOuter: {
                backgroundColor: '#999',
                border: "none",
            },
            buttonNext: {
                backgroundColor: '#58c8d1',
                color: '#0c0c0c',
            },
            buttonBack: {
                color: '#0c0c0c'
            }
        } }));
};
exports.ProductTour = ProductTour;
